import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import { Step } from "@/typings/step";

type ClearActionProps = {
  step: Step;
  onClear: () => void;
};

export function ClearAction({ step, onClear }: ClearActionProps): ReactNode {
  const canClear = [Step.RoundOne, Step.RoundTwo, Step.RoundThree].includes(step);

  return canClear ? (
    <button className={styles.clearButton} onClick={onClear}>
      <div className={styles.clearText}>Clear</div>
    </button>
  ) : null;
}
